import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    ...theme.layouts.stepGrid,
    gridMainContainer: {
      padding: '.5rem 1rem 1rem 1rem',
      margin: 'auto',
      maxWidth: '1280px',
    },
    checkboxContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    ul: {
      paddingLeft: '1.5rem',
      '& li': {
        fontSize: '1rem',
      },
    },
    checkbox: {
      '& span': {
        '& svg': {
          width: '36px',
          height: '36px',
        },
      },
    },
    inputFields: {
      maxWidth: '24.5rem',
      width: '100%',
    },
    actionButton: {
      paddingBottom: '3rem',
      marginTop: '3rem',
      '& button': {
        minWidth: '13rem',
        '@media (min-width: 321px)': {
          minWidth: '18rem',
        },
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        '& button': {
          margin: '1rem 0',
        },
      },
    },
    secondPointButton: {
      marginTop: '3rem',
      '& button': {
        minWidth: '13rem',
        '@media (min-width: 321px)': {
          minWidth: '18rem',
        },
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        '& button': {
          margin: '1rem 0',
        },
      },
    },
    responsivePadding: {
      marginTop: '1.5rem',
      '@media (min-width: 767px)': {
        marginTop: '3rem',
      },
    },
    dobField: {
      minWidth: '18rem',
    },
    maxWidth90: {
      maxWidth: '90%',
    },
    maxWidth24: {
      maxWidth: '24.5rem',
    },
  }),
  { index: 1 },
);
